import { CardBackground } from "@hellocarbo/lasagne";
import { List, Root } from "@radix-ui/react-navigation-menu";
import { useTranslation } from "react-i18next";

import { NavigationLink } from "@/components/Shared";
import useSegmentEvent from "@/hooks/useSegmentEvent";

function Navigation() {
  const { t } = useTranslation(["trajectory"]);
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <CardBackground className="mb-sm">
      <Root orientation="horizontal">
        <List className="gap-x-sm flex">
          <NavigationLink
            href="/trajectory/action-plan"
            onClick={() => sendSegmentEvent("action-plan-trajectory-summary")}
          >
            {t("trajectory:pages.trajectory")}
          </NavigationLink>
          <NavigationLink
            href="/trajectory/projections"
            onClick={() => sendSegmentEvent("action-plan-projections-summary")}
          >
            {t("trajectory:pages.projections")}
          </NavigationLink>
          <NavigationLink
            href="/trajectory/context"
            onClick={() => sendSegmentEvent("action-plan-pedagogy-summary")}
          >
            {t("trajectory:pages.context")}
          </NavigationLink>
        </List>
      </Root>
    </CardBackground>
  );
}

export default Navigation;
